<template>
  <div class="content">
     <el-form :model="queryParams" ref="queryForm"  :inline="true">
      <el-form-item prop="productName">
        <el-input
          v-model="queryParams.productName"
          placeholder="请输入套餐名称"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-select v-model="queryParams.productType" filterable clearable placeholder="请输入套餐类型">
          <el-option v-for="item in productTypes" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="openSelectProdcut"
          v-hasPermi="['agent:customProduct:save']"
        >自定义国际套餐价格</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-close"
          @click="handleClose"
        >关闭</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" border :data="productList" >
      <el-table-column fixed label="套餐ID" prop="id" align="center" :show-overflow-tooltip="true" />
      <el-table-column fixed label="套餐名称" prop="productName" min-width="160" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="套餐类型" prop="productType" align="center" :show-overflow-tooltip="true" />
      
      <el-table-column prop="products" label="区域价格" align="center" width="620px">
        <template slot-scope="{row}">
          <div class="product-list">
            <div class="product-item" v-for="(item,index) in row.products.slice(0, 3)" :key="index"  
                  :title="'【'+item.countryName+'】' +' 售价('+item.currencySymbal + item.price +')'">
                  <span>【{{item.countryName}}】：  售价({{item.currencySymbal}}{{item.price}})</span>
            </div>
            <span class="el-dropdown-link" v-if="row.products.length>3" @click="showMoreProduct(row)">
              <i class="el-icon-d-arrow-right el-icon--right"></i>更多
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="套餐总量/M" prop="flowCount" align="center" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="套餐有效期/天" prop="validityTime" align="center" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column prop="channel" label="渠道" align="center" width="100px">
        <template slot-scope="{row}">
          <span v-if="row.channel == 'cmlink'">ZY国际</span>
          <span v-if="row.channel == 'cmBrazil'">中移巴西</span>
          <span v-if="row.channel == 'multi'">RX国际</span>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" align="center" min-width="130" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-circle-close"
            @click="customProductCancel(scope.row)"
            v-hasPermi="['agent:customProduct:cancel']"
            v-if="scope.row.customProduct == '1' && scope.row.source=='1'"
          >删除</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="customProductEdit(scope.row)"
            v-hasPermi="['agent:customProduct:cancel']"
            v-if="scope.row.customProduct == '1' && scope.row.source=='1'"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    <select-internation-product ref="select" :userId="queryParams.userId" @ok="handleQuery" />
    <update-internation-product ref="update" :updateProduct="updateProduct" @ok="handleQuery" />
    <el-dialog title="区域价格列表" :visible.sync="moreProductOpen" width="900px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchQuery" clearable style="width: 30%"></el-input>
      <el-table :data="filteredTableData" height="650"  style="width: 100%">
        <el-table-column prop="countryName" label="使用区域"></el-table-column>
        <el-table-column prop="currency" label="收款货币代码" ></el-table-column>
        <el-table-column prop="currencySymbal" label="收款货币符号"></el-table-column>
        <el-table-column prop="price" label="售价"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {customInternationalProduct, customProductCancel } from "@/api/api";
import selectInternationProduct from "./selectInternationProduct";
import UpdateInternationProduct from "./UpdateInternationProduct";

export default {
  components: { selectInternationProduct , UpdateInternationProduct},
  data() {
    return {
      // 遮罩层
      loading: true,
      // 非多个禁用
      multiple: true,
      // 总条数
      total: 0,
      // 代理商套餐表格数据
      productList: [],
      pageNum: 1,
      pageSize: 20,
      // 查询参数
      queryParams: {
        userId: undefined,
        productName: undefined,
        productType: undefined
      },
      productTypes:[
        {"value":"累计套餐","key":1},
        {"value":"月套餐","key":2},
        {"value":"加油包","key":3}
      ],
      updateProduct:{
        userId: undefined,
        productId:undefined,
        channle:undefined
      },
      moreProductOpen:false,
      moreProductData:[],
      searchQuery:''
    };
  },
  computed:{
    filteredTableData() {
      return this.moreProductData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    }
  },
  watch: {
    // 监听路由中userId参数变化
    '$route.params.userId'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        sessionStorage.setItem('agentProduct', newVal);
        this.queryParams.userId = newVal;
        this.resetQuery(); // 重置搜索条件
      }
    }
  },
  created() {
    const userId = this.$route.params && this.$route.params.userId;
    if (userId) {
      sessionStorage.setItem('agentProduct', userId);
      this.queryParams.userId = userId;
      this.getList();
    }else{
      this.queryParams.userId = sessionStorage.getItem('agentProduct');
      this.getList();
    }
  },
  methods: {
    /** 查询代理商套餐列表 */
    getList() {
      this.loading = true;
      let params = {
        model: {
          ... this.queryParams
        },
        page: this.pageNum,
        pageSize: this.pageSize
      }
      customInternationalProduct(params).then(res => {
          this.productList = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }
      );
    },
    // 返回按钮
    handleClose() {
      const obj = { path: "/partners/agent" };
      this.$tab.closeOpenPage(obj);
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    openSelectProdcut() {
      this.$refs.select.show();
    },
    customProductEdit(row){
      this.updateProduct = {
        userId: this.queryParams.userId,
        productId: row.id,
        channel: row.channel
      }
      this.$refs.update.show();
    },
    /** 取消自定义套餐价格 */
    customProductCancel(row) {
      let userId = this.queryParams.userId
      this.$modal.confirm('确认要删除"' + row.productName + '"设置的自定义价格？').then(function() {
        return customProductCancel({ userId: userId, productId: row.id });
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("取消授权成功");
      }).catch(() => {});
    },
    showMoreProduct(item){
      this.moreProductOpen = true
      this.moreProductData = item.products
    },
  }
};
</script>
<style scoped lang="less">
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 620px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 290px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
</style>